import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

const TOKEN = /("(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*')|(\/(?:[^/\\\n]|\\.)+\/)|(\$[A-Za-z_]\w*)|(\b\d+(?:\.\d+)?\b)|([?:;&|=!<>+\-*]+)|(`[^`]*`)/g;

const CLASS_BY_GROUP = ['str', 'regex', 'fn', 'num', 'op', 'field'];

@Component({
  selector: 'app-jsonata-field',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './jsonata-field.component.html',
  styleUrls: ['./jsonata-field.component.scss'],
})
export class JsonataFieldComponent {
  @Input() value = '';
  @Input() rows = 3;
  @Input() placeholder = '';
  @Output() valueChange = new EventEmitter<string>();

  get highlighted(): string {
    const escaped = (this.value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    const marked = escaped.replace(TOKEN, (match, ...groups) => {
      const index = groups.slice(0, CLASS_BY_GROUP.length).findIndex(g => g !== undefined);
      return index === -1 ? match : `<span class="tk-${CLASS_BY_GROUP[index]}">${match}</span>`;
    });

    return marked + '\n';
  }

  onInput(next: string): void {
    this.value = next;
    this.valueChange.emit(next);
  }

  syncScroll(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    const pre = textarea.previousElementSibling as HTMLElement | null;
    if (pre) {
      pre.scrollTop = textarea.scrollTop;
      pre.scrollLeft = textarea.scrollLeft;
    }
  }
}
